import "./infoHint.css";
import { useState } from "react";
import { Dropdown } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

/**
 * The "i" next to a setting or a number: click it to see, in plain words, how it works
 * or how the figure was reached. `lines` are strings or {title, text} (the working the
 * server sends back with every holiday balance / preview); `warnings` show underneath.
 * Antd Dropdown + dropdownRender rather than Popover, portalled to body so it sits above
 * drawers and modals.
 */
export const InfoHint = ({ title, lines = [], warnings = [], children, placement = "bottomLeft", width = 380 }) => {
    const [open, setOpen] = useState(false);
    return (
        <Dropdown
            trigger={["click"]}
            open={open}
            onOpenChange={setOpen}
            placement={placement}
            getPopupContainer={() => document.body}
            overlayStyle={{ zIndex: 2100 }}
            dropdownRender={() => (
                <div className="info-hint-panel" style={{ width }} onClick={(e) => e.stopPropagation()}>
                    {title && <div className="info-hint-title">{title}</div>}
                    {children}
                    {lines?.length > 0 && (
                        <div className="info-hint-lines">
                            {lines.map((line, i) => (
                                typeof line === "string"
                                    ? <div key={i} className="info-hint-line">{line}</div>
                                    : <div key={i} className="info-hint-line">
                                        <div className="info-hint-line-title">{line?.title}</div>
                                        <div>{line?.text}</div>
                                    </div>
                            ))}
                        </div>
                    )}
                    {warnings?.length > 0 && (
                        <div className="info-hint-warnings">
                            {warnings.map((warning, i) => (
                                <div key={i} className="info-hint-warning">
                                    <FontAwesomeIcon icon={faTriangleExclamation} /> <span>{warning}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        >
            <span
                className="info-hint-icon"
                role="button"
                aria-label={title ? `How ${title.toLowerCase()} works` : "How this works"}
                onClick={(e) => e.stopPropagation()}
            >
                <FontAwesomeIcon icon={faCircleInfo} />
            </span>
        </Dropdown>
    );
};
